<template>
  <ServiceInfo :data="data" />
</template>

<script>
import ServiceInfo from "../../components/serviceInfo/ServiceInfo.vue";
import { advertisingInfo } from "../../textual/info";
export default {
  components: {
    ServiceInfo,
  },
  computed: {
    data() {
      return advertisingInfo;
    },
  },
};
</script>
